// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2dMcJ","content":"styles_content___VbQ8"};